import { useSearchParams } from "react-router";

export function usePrefillValueFromQuery(): {
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  couponCode: string | undefined;
} {
  const [searchParams] = useSearchParams();

  const email = searchParams.get("em") ?? undefined;
  const firstName = searchParams.get("fn") ?? undefined;
  const lastName = searchParams.get("ln") ?? undefined;
  const couponCode = searchParams.get("couponcode") ?? undefined;

  return {
    email,
    firstName,
    lastName,
    couponCode,
  };
}
